<template>
  <component :is="comp" v-if="variant" />
  <div v-else style="min-height:60vh"></div>
</template>

<script>
// Route-level gate for the Company Profile REPORT screen (/companies/:id/profile).
// Same URL as always; profileFlag decides which UI renders. Hard default is the
// classic (shipped) component — flag off, PostHog blocked, or flags not loaded in
// time all land there, so this is a safe no-op until the flag is turned on.
//
// Switch back to the old UI any time via ?cp_ui=old (or localStorage / turning the
// PostHog flag off) — see profileFlag.js.
//
// Classic is imported eagerly because it is the default path (no extra chunk fetch
// for the common case); the redesign is lazy-loaded only when the flag serves it.
import CompanyProfileClassic from './CompanyProfile.vue';
import { resolveCompanyProfileVariant } from './profileFlag';

export default {
  name: 'company-profile-gate',
  data() {
    return { variant: null };
  },
  computed: {
    comp() {
      return this.variant === 'new'
        ? () => import('./CompanyProfileRedesign.vue')
        : CompanyProfileClassic;
    },
  },
  async created() {
    this.variant = await resolveCompanyProfileVariant();
  },
};
</script>
